import { render, staticRenderFns } from "./historyForm.vue?vue&type=template&id=f4fd4694&scoped=true&"
import script from "./historyForm.vue?vue&type=script&lang=js&"
export * from "./historyForm.vue?vue&type=script&lang=js&"
import style0 from "./historyForm.vue?vue&type=style&index=0&id=f4fd4694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fd4694",
  null
  
)

export default component.exports